import { Stack } from '@/ux-common/components/stack/stack';
import { Typography } from '@/ux-common/components/typography/typography';

export const EmptySelectionsList = () => {
  return (
    <Stack className="p-4 text-center">
      <Typography as="p" className="text-body-base text-ckds-text-fg-tier3">
        No devices with trend points found for this facility
      </Typography>
    </Stack>
  );
};
